import { io } from 'socket.io-client';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5004';

const WEB_WEBSOCKET_NAMESPACE = `api/web`;

export const socket = io(`${API_URL}/${WEB_WEBSOCKET_NAMESPACE}`, {
  path: '/socket.io',
  transports: ['websocket'],
  autoConnect: false,
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionAttempts: 5,
});
